import img1 from "../assets/features-img/img1.png";
import img2 from "../assets/features-img/img2.png";
import img3 from "../assets/features-img/img3.png";
const Fdata = [
  {
    img: img3,
    heading: "OpenType features Variable fonts",
    passage:
      "Slate helps you see how many more days you need to work to reach your financial goal.",
  },
  {
    img: img1,
    heading: "Design with real data",
    passage:
      "Slate helps you see how many more days you need to work to reach your financial goal.",
  },
  {
    img: img2,
    heading: "Fastest way to take action",
    passage:
      "Slate helps you see how many more days you need to work to reach your financial goal.",
  },
];

export default Fdata;
